import { LucideIcon } from "lucide-react";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "./ui/sidebar";
import { usePathname, useRouter } from "next/navigation";

type NavSecondaryProps = {
  items: {
    title: string;
    url: string;
    className?: string;
    pages?: {
      title: string;
      url: string;
      icon: LucideIcon;
    }[];
  }[];
} & React.ComponentProps<typeof SidebarGroup>;

export function NavSecondary({ items }: NavSecondaryProps) {
  const router = useRouter();
  const pathname = usePathname();
  const { setOpenMobile, isMobile } = useSidebar();

  return (
    <>
      {items.map((item) => (
        <SidebarGroupContent
          key={item.title}
          className={`px-2 pb-4 pt-2 ${item.className}`}
        >
          <SidebarGroupLabel className="font-display font-medium text-muted">
            {item.title}
          </SidebarGroupLabel>
          <SidebarMenu>
            {item.pages?.map((page) => (
              <SidebarMenuItem key={page.title}>
                <SidebarMenuButton
                  variant="custom"
                  onClick={() => {
                    if (isMobile) setOpenMobile(false);
                    if (page.url.includes("http")) {
                      window.open(page.url, "_blank");
                    } else {
                      router.push(page.url);
                    }
                  }}
                  isActive={pathname.includes(page.url)}
                  className="px-2.5 font-display font-medium md:px-1.5"
                >
                  <page.icon
                    className={`text-muted ${["Discord", "PowerOn Pro"].includes(page.icon.displayName || "") && "fill-muted"}`}
                  />
                  <span>{page.title}</span>
                </SidebarMenuButton>
              </SidebarMenuItem>
            ))}
          </SidebarMenu>
        </SidebarGroupContent>
      ))}
    </>
  );
}
